<script setup lang="ts">
// Import defineProps to define the component props
import { computed, defineProps } from 'vue'
import { CDN } from '@/models/cdn.ts'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

// Define the props your component expects
const props = defineProps({
  type: {
    type: Number,
    required: true
  },
  size: {
    type: Number,
    default: 2
  }
});
// Calculate the width and height of the image based on the planet size with adjusted scaling
const imageSize = computed(() => {
  if (props.size === 1) return 1.8;
  if (props.size === 2) return 2.0;
  return props.size * 0.8;
})


</script>

<template>
  <img
      :src="CDN.planet(64, props.size, props.type)"
      :alt="props.type === 8 ? t('game.planets.types.ringworld') : t('game.planets.size', { size: props.size })"
      :title="props.type === 8 ? t('game.planets.types.ringworld') : t('game.planets.size', { size: props.size })"
      :style="'width: ' + imageSize + 'rem; height: ' + imageSize + 'rem;'"
  >
</template>

<style scoped lang="scss">

</style>
